import { datadogRum } from "@datadog/browser-rum";
import { datadogLogs } from "@datadog/browser-logs";
import { reactPlugin } from "@datadog/browser-rum-react";
import { createBrowserRouter as createReactRouter } from "react-router-dom";
import { createBrowserRouter as createDatadogRouter } from "@datadog/browser-rum-react/react-router-v6";
import {
  currentEnv,
  buildNumber,
  isDevelopment,
  datadogApplicationId,
  datadogClientToken,
  datadogSite,
} from "./environment";

export const isDatadogEnabled = (): boolean =>
  Boolean(datadogApplicationId && datadogClientToken);

export const datadogRumSetup = (): void => {
  if (isDevelopment || !isDatadogEnabled()) return;

  datadogRum.init({
    applicationId: datadogApplicationId!,
    clientToken: datadogClientToken!,
    site: datadogSite,
    service: "smartli-app",
    version: String(buildNumber || "unknown"),
    env: currentEnv,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 0,
    trackResources: true,
    trackUserInteractions: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask-user-input",
    usePartitionedCrossSiteSessionCookie: true,
    plugins: [reactPlugin({ router: true })],
  });

  datadogLogs.init({
    clientToken: datadogClientToken!,
    site: datadogSite,
    service: "smartli-app",
    env: currentEnv,
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ["error", "warn"],
    sessionSampleRate: 100,
  });
};

export const getCreateBrowserRouter = () =>
  isDatadogEnabled() && !isDevelopment ? createDatadogRouter : createReactRouter;
